import React from 'react';
import { UploaderProvider, useModal } from '@europrocurement/flexy-components';
import { GenericModalMailType } from '@europrocurement/flexy-components/types/GenericModalMailType';
import GenericModalMailContent from '../components/GenericModalMailContent/GenericModalMailContent';

const useModalMail = () => {
    const { modalActions } = useModal();

    const showMailModal = (propsGenericModalMail: GenericModalMailType) => {
        modalActions.call(
            <UploaderProvider>
                <GenericModalMailContent {...(propsGenericModalMail as GenericModalMailType)} />
            </UploaderProvider>,
            true,
        );
    };

    return { showMailModal };
};

export default useModalMail;
